<template>
  <div>
    <!-- Profile Image -->
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Tài khoản đồng bộ</h3>
      </div>
      <div class="box-body box-profile">
        <img class="profile-user-img img-responsive img-circle"
             :src="account.picture_url ? account.picture_url : '/assets/imgs/user_default.png'"
             alt="User profile picture">
        <h3 class="profile-username text-center">
          <a :href="account.fbLink" target="_blank"><i class="fa fa-facebook-official"> {{ account.name }}</i></a>
        </h3>
        <button class="btn btn-block btn-social btn-danger" @click="removeFacebookAccount">
          <i class="fa fa-facebook"></i>Remove Account
        </button>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Thông Tin Tài Khoản</h3>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
        <ul class="list-group list-group-unbordered">
          <li class="list-group-item">
            <b>Tên: </b> <span class="pull-right btn-link">{{ account.username }}</span>
          </li>
          <li class="list-group-item">
            <b>Email: </b> <span class="pull-right btn-link">{{ account.email }}</span>
          </li>
          <li class="list-group-item">
            <b>Số Điện Thoại: </b> <span class="pull-right btn-link">{{ account.phone }}</span>
          </li>
          <li class="list-group-item">
            <b>Gói cước </b> <span class="pull-right btn-link">{{ account.package }}</span>
          </li>
          <li class="list-group-item">
            <b>Ngày hết hạn </b> <span class="pull-right btn-link">{{ account.expireDate }}</span>
          </li>
          <li class="list-group-item">
            <b>Số Fanpage</b> <span class="pull-right btn-link">{{ account.fanPageCount }}</span>
          </li>
          <li class="list-group-item">
            <b>Số User</b> <span class="pull-right btn-link">{{ account.userCount }}</span>
          </li>
          <li class="list-group-item">
            <b>Số Showroom</b> <span class="pull-right btn-link">{{ account.showroomCount }}</span>
          </li>
        </ul>
      </div>
      <!-- /.box-body -->
    </div>
  </div>
</template>

<script>
import FacebookPageApi from '../../api/facebookPage'

export default {
  name: 'AccountInfo',
  props: {
    'account': {
      type: Object,
      default: {}
    },
  },
  methods: {
    removeFacebookAccount () {
      FacebookPageApi.remove_account()
        .then(res => {
          this.$emit('remove-account')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.btn-facebook:hover {
  color: #fff;
  background-color: #2d4373;
  border-color: rgba(0, 0, 0, 0.2);
}

.btn-facebook {
  color: #fff;
  background-color: #3b5998;
  border-color: rgba(0, 0, 0, 0.2);
}

.example-modal .modal-header {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
  justify-content: normal;
}

.btn-link:hover {
  text-decoration: none;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.list-group-unbordered > .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/social_network/AccountInfo.vue